import React, { useEffect, useState } from 'react';
import { Input, Select, SelectProps } from 'antd';
import { useDebounce } from 'util/Hooks';
import { JourneyKind } from 'interfaces/journey';

export const KIND_LABELS: Record<JourneyKind, string> = {
  shipments: 'Envíos',
  collections: 'Colectas',
  mixed: 'Mixta',
};

export const kindColumn = {
  title: 'Tipo',
  dataIndex: 'kind',
  key: 'kind',
  align: 'center',
  width: '7%',
  render: (kind?: JourneyKind) => KIND_LABELS[kind ?? 'shipments'],
};

export const KindSelect = ({
  onChange,
}: {
  onChange: SelectProps<JourneyKind>['onChange'];
}) => (
  <Select
    allowClear
    placeholder="Tipo"
    style={{ width: 130 }}
    options={Object.entries(KIND_LABELS).map(([value, label]) => ({
      value,
      label,
    }))}
    onChange={onChange}
  />
);

export const nameColumn = {
  title: 'Nombre',
  dataIndex: 'name',
  key: 'name',
  width: '12%',
  ellipsis: true,
  render: (name?: string) => name || '-',
};

export const RouteSearch = ({
  onSearch,
  placeholder = 'Buscar por nombre o ID',
}: {
  onSearch: (value?: string) => void;
  placeholder?: string;
}) => {
  const [text, setText] = useState('');
  const debounced = useDebounce(text, 600) as string;

  useEffect(() => {
    onSearch(debounced.trim() || undefined);
  }, [debounced, onSearch]);

  return (
    <Input.Search
      allowClear
      value={text}
      placeholder={placeholder}
      style={{ width: 240 }}
      onChange={(event) => setText(event.target.value)}
      onSearch={(value) => onSearch(value.trim() || undefined)}
    />
  );
};
